<template>
  <section class="hero" id="hero">
    <div class="hero__text">
      <div class="hero__text-title">
        <h1>{{ header.title }}</h1>
      </div>
      <div class="hero__text-subtitle">
        <h3>{{ header.details }}</h3>
      </div>
      <div class="btn__container">
          <MonButton
            text="CONTÁCTANOS"
            ui="primary tiny"
            @btnClick="ItemClick"
          />
      </div>
      <ArrowNavigator destiny="#nosotros" /> 
    </div>
  </section>
</template>
<script>
import MonButton from "@/components/atoms/Button.vue";
import ArrowNavigator from "@/components/atoms/ArrowNavigator.vue";
import newTexts from "@/data/newTexts"

export default {
  name: "Hero",
  components: {
    MonButton,
    ArrowNavigator
  },
  data() {
    return {
      header: newTexts.heroSection,
    };
  },
  mounted(){
    const options = {
      root: null,
      thresold: 1,
      rootMargin: "0px"
    }
    function triggerAnimation(entries){
      const section = document.getElementById("hero");
      if (entries[0].isIntersecting) {
        section.classList.add("unset"); 
      }
    }
    const aboutUsSection = document.getElementById("hero")
    const observer = new IntersectionObserver(triggerAnimation, options)
    observer.observe(aboutUsSection)  
  },

  methods: {
    ItemClick() {
      this.$router.push({ name: "Home", hash: "#contacto" });
    },
  },
};
</script>
